import type { ComponentProps } from 'react';
import { type Stack } from 'expo-router';
import { StyleSheet } from 'react-native';

import { theme, TYPE_CONFIG } from '@sg/garnish';

import { defaultHeaderLeft } from '../components/DefaultHeaderLeft';

// ─── Colors ─────────────────────────────────────────────────────────────────

export const APP_BACKGROUND = theme.colors.APP_BACKGROUND;

// ─── Base ────────────────────────────────────────────────────────────────────

/**
 * Base screen options shared by all Stack navigators.
 */
export const DEFAULT_SCREEN_OPTIONS = {
  headerShown: false,
  contentStyle: { backgroundColor: APP_BACKGROUND },
} satisfies ScreenOptions;

// ─── Header ──────────────────────────────────────────────────────────────────

/**
 * Screen options for Stack navigators that show native headers.
 */
export const SCREEN_HEADER_OPTIONS = {
  headerShadowVisible: false,
  headerTintColor: theme.colors.GREEN_1,
  headerStyle: { backgroundColor: APP_BACKGROUND },
  headerTitleStyle: TYPE_CONFIG.BODY['18'] as ScreenOptions['headerTitleStyle'],
  headerTitleAlign: 'center',
  headerBackVisible: false,
  headerTitle: '',
  headerLeft: defaultHeaderLeft,
} satisfies ScreenOptions;

// ─── Styles ──────────────────────────────────────────────────────────────────

export const CONTENT_WITH_BG_COLOR_STYLES = { backgroundColor: APP_BACKGROUND };
export const CONTENT_WITHOUT_BG_STYLES = { backgroundColor: 'transparent' };

export const SLOT_CONTAINER_STYLES = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: APP_BACKGROUND,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

export type ScreenOptions = Extract<
  NonNullable<ComponentProps<typeof Stack>['screenOptions']>,
  Record<string, unknown>
>;

/**
 * Return type used with `satisfies` for object literal validation.
 */
export type ScreenOptionsMap = Record<string, ScreenOptions & Record<string, unknown>>;
